import { AppConfig } from '../../AppConfig';

export class MetaDataHelper {
  static getMetaData(key) {
    switch (key) {
    default:
      return {
        descr: AppConfig.DASHBOARD_COMMON_TITLE,
        searchable: AppConfig.SEARCHABLE || AppConfig.DASHBOARD_COMMON_TITLE,
        title: AppConfig.DASHBOARD_COMMON_TITLE
      }
    }
  }

  static processMetaData = (page, data) => {
    const defaultMetadata = MetaDataHelper.getMetaData(page)
    const metaData = data || {}

    if (!metaData.title) {
      metaData.title = defaultMetadata.title
    }
    if (!metaData.searchable) {
      metaData.searchable = defaultMetadata.searchable
    }
    if (!metaData.descr) {
      metaData.descr = defaultMetadata.descr
    }
    return {
      title: metaData.title,
      description: metaData.descr,
      keywords: metaData.searchable
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/helpers/MetaDataHelper.js